import { Allegato, Configuration, HandleFileUploadRequest, OnboardingApi } from "@api/client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { errorHandler } from "core/store/config";
import { FileDocument } from "models/files";

enum FileReduce {
	upload = "[FILE] Upload file",
}

export const fileUpload = createAsyncThunk<Allegato[] | undefined, FileDocument[], ThunkApiConfig>(
	FileReduce.upload,
	async (files, { dispatch, extra, getState }) => {
		if (files.length < 1) return;

		let pratica = getState().pratica;
		let idPratica = pratica?.idPratica;
		let reopenPratica = getState().pratica.reopenPratica;
		let datetime = new Date().getTime();

		let uploadPromises: any[] = [];
		let progress: number = 0;

		files?.forEach((fileToUpload) => {
			if (!idPratica) return;

			const parts = fileToUpload.name.split(".");
			const fileExtension = parts[parts.length - 1];

			const idAllegato: (string | undefined)[] | undefined = reopenPratica?.allegatiToUpload
				?.filter(
					(e) =>
						e.idSoggetto === fileToUpload.idSoggetto &&
						e.idTipoDocumento === fileToUpload.idTipoDocumento
				)
				.map((e) => e.idAllegato);

			console.log("fileToUpload", fileToUpload);

			let request: HandleFileUploadRequest = {
				file: fileToUpload,
				filename: `${fileToUpload.idTipoDocumento}_${datetime}.${fileExtension}`,
				idTipoAllegato: fileToUpload.idTipoAllegato,
				idTipoDocumento: fileToUpload.idTipoDocumento,
				idPratica,
				idSoggetto: fileToUpload.idSoggetto,
				idAllegato: idAllegato?.length ? idAllegato[0] : undefined,
			};

			uploadPromises.push(
				new OnboardingApi(getConfiguration(Configuration, extra, getState)).handleFileUpload1(
					request
				)
			);
		});

		try {
			return await Promise.all<Allegato>(uploadPromises);
		} catch (e) {
			errorHandler(e, dispatch);
		}
	}
);
